export default {
  account: {
    setting: "Mój profil",
    default_price_list: "Domyślny cennik badań laboratoryjnych",
    pwz: "Nr PWZ",
    personal_data: "Dane podstawowe",
    email: "Adres e-mail",
    password: "Hasło",
    update_data: "Edytuj swoje dane",
    change_password: "Zmień swoje hasło",
    blocked: "Zostałeś zablokowany",
    contact_administrator: "Skontaktuj się z administratorem",
    key_customer_sector:
      "Jeżeli już posiadasz swojego opiekuna z sektora centralnego – wybierz z listy",
    keeper: "Opiekun",
    profile: "Mój profil",
    services: "Usługi",
    hours: "Stałe godziny pracy",
    work_hours: "Godziny pracy",
    settings: "Ustawienia",
    clinic_profile: "Profil placówki",
    employees: "Pracownicy",
    invoice_data: "Dane do faktury",
    profile_preview: "Podgląd profilu",
    about_me: "O mnie",
    treated_diseases: "Leczone choroby",
    write_and_add: "Wpisz i dodaj...",
    education: "Edukacja",
    internships: "Staże",
    languages: "Znajomość języków",
    viewing_profile: "Wyświetlanie profilu",
    show_profile: "Ukryj profil",
    hide_profile: "Ukryj profil",
    show_profile_info:
      "Ta opcja tymczasowo ukryje twój profil na stronach ewizyty. Co oznacza, że żaden z pacjentów nie będzie mógł cię znaleźć ani umówić się na wizytę.",
    your_data: "Twoje dane",
    full_name: "Imię i Nazwisko",
    contact_details: "Dane Kontaktowe",
    specialization: "Specjalizacja",
    phone_number: "Numer telefonu",
    empty_specialization: "Nie wybrano specjalizacji",
    change_psw: "Zmień hasło",
    your_password: "Twoje hasło",
  },

  settings: {
    services: {
      title: "Usługi",
      confirm_delete_service: "Czy jesteś pewien, że chcesz usunąć tę usługę?",
      confirm_delete_button: "Usuń",
      edit_btn: "Edytuj",
      remove_btn: "Usuń",
      add_next_service: "Dodaj kolejną usługę",
    },
    my_profile: {
      profile_preview: "Podgląd profilu",
      about_me: "O mnie",
      form: {
        inputs: {
          about_me: {
            label: "O mnie",
            placeholder: "Wpisz i dodaj",
          },
          treated_diseases: {
            label: "Leczone choroby",
            placeholder: "Wpisz i dodaj",
          },
          education: {
            label: "Edukacja",
            placeholder: "Wpisz i dodaj",
          },
          internships: {
            label: "Staże",
            placeholder: "Wpisz i dodaj",
          },
          languages: {
            label: "Znajomość języków",
            placeholder: "Wpisz i dodaj",
          },
        },
        save_btn_text: "Zapisz zmiany",
      },
      viewing_profile: "Wyświetlanie profilu",
      show_profile: "Pokaż profil",
      hide_profile: "Ukryj profil",
      show_profile_info:
        "Ta opcja tymczasowo ukryje twój profil na stronach ewizyty. Co oznacza, że żaden z pacjentów nie będzie mógł cię znaleźć ani umówić się na wizytę.",
    },
    visit_intervals: "W jakich odstępach czasowych chcesz przyjmować pacjentów",
    apply_changes_date: "Od kiedy chcesz wprowadzić zmiany w grafiku",
    apply_changes_desc:
      "Zmiany mogą spowodować problemy z wizytami. Najdalej wysunięta wizyta 20.03.2023",
    sms_notification: "Powiadomienia SMS",
    notification: "Powiadomienia do pacjentów",
    notification_desc:
      "Aktywuj usługę aby wysyłać automatycznie powiadomienia do pacjentów o wizytach.",
    notification_types: "Typy powiadomień",
    reserve_visit: "Zarezerwowane wizyty - zaraz po umówieniu wizyty",
    remind_visit: "Przypomnienie o wizycie - 24 godziny przed wizytą",
    cancel_visit: "Anulowanie wizyty",
    change_visit: "Zmiana terminu wizyty",
    sms_request: "SMS okolicznościowy",
    sms_request_desc:
      "Wiadomość którą możesz wysłać do wybranej grupy odbiorców aby poinformować ich o jakiejś nagłej sytuacji lub po prostu złożyć życzenia świąteczne",
    send_sms: "Wyślij SMS",
    sms_template: "Szablony SMS",
    book_visit: "Zarezerwowanie wizyty i przypomnienie",
    add_content: "Dodaj do treści",
    sms_template_button: {
      doctor: "Lekarz",
      localization: "Lokalizacja",
      date: "Data",
      hour: "Godzina",
    },
    employee_table: {
      status: "Status",
      full_name: "Imię i Nazwisko",
      medic_licence: "Nr licencji medycznej",
      mail: "E-mail",
      phoneNumber: "Telefon",
      role: "Rola",
      filled_profile: "Wypełniony profil",
    },
    appointment_hours: {
      title: "Stałe godziny pracy",
      add_new_schedule: "Utwórz nowy grafik",
      current_working_hours: {
        title: "Obecny grafik",
        effective_from: "Obowiązuje od",
      },
      upcoming_working_hours: {
        title: "Przyszły grafik",
        add_title: "Nowy grafik",
        effective_from: "Obowiązuje od",
        meeting_interval: {
          title: "W jakich odstępach czasowych chcesz przyjmować pacjentów",
          sub_title:
            "Opcja domyślnie ustawiona dla każdego lekarza, edytowalna indywidualnie.",
        },
        working_hours_effective: {
          title: "Czas obowiązywania grafiku",
          change_info:
            "Zmiany mogą spowodować  problemy z już umówionymi wizytami. Najdalej wysunięta wizyta",
        },
      },
    },
  },

  action: {
    next: "Dalej",
    change: "Zmień",
    see_details: "Zobacz szczegóły",
    see_doctor: "Zobacz lekarza",
    see_referral: "Zobacz zlecenie",
    go_back: "Wróć",
    save_changes: "Zapisz zmiany",
    choose: "Wybierz",
    continue: "Kontynuuj",
    save: "Zapisz",
    clear: "Wyczyść",
    return: "Powrót",
    filter: "Filtruj",
    withdraw_funds: "Wypłać środki",
    edit: "Edytuj",
    download: "Pobierz",
    expand: "Rozwiń",
    collapse: "Zwiń",
    add: "Dodaj",
    add_to_referral: "Dodaj do zlecenia",
    search: "Szukaj",
    cancel: "Anuluj",
    show_more: "Zobacz więcej",
    add_employee: "Dodaj pracownika",
    start_call: "Rozpocznij wizytę",
    save_as_draft: "Zapisz jako wersję roboczą",
    send_to_patient: "Wyślij do pacjenta",
    exit_without_saving: "Wyjdź bez zapisywania",
    submit: "Zapisz",
    skip_and_submit: "Pomiń i zapisz",
  },

  admin: {
    cities: {
      all: "Wszystkie",
    },
    message: {
      title: "Tytuł",
      message: "Treść wiadomości",
      send: "Wyślij wiadomość",
      choose_doctors: "Zaznacz do kogo chcesz wysłać wiadomość",
      sent: "Wiadomość została wysłana do",
      recipients: "odbiorcy/ów",
      recipients_number: "Liczba odbiorców",
    },

    doctor: {
      create: "Dodaj lekarza",
      doctor_data: "Dane lekarza",
      company_data: "Dane firmy",
      address: "Adres",
      account_number: "Numer rachunku bankowego",
      first_name: "Imię",
      last_name: "Nazwisko",
      pwz: "PWZ",
      main_medical_category: "Specjalizacja",
      email: "E-mail",
      registered_at: "Data rejestracji",
      phone_number: "Telefon",
      company_name: "Nazwa firmy / przychodni",
      nip: "NIP",
      street: "Ulica",
      house_number: "Numer budynku",
      flat_number: "Numer lokalu",
      postal_code: "Kod pocztowy",
      city: "Miasto",
      edit: "Zapisz dane",
      data_edit: "Edycja danych",
      referrrals_list: "Lista zleceń",
      send_message: "Wyślij wiadomość",
      status: "Status",
      full_name: "Imię i nazwisko",
      commission: "Wynagrodzenie",
      company: "Firma",
      back_to_list: "Wróć do listy lekarzy",
      search_doctor: "Znajdź lekarza",
      search_patient: "Znajdź pacjenta",
      account_inactice: "Konto jest nieaktywne",
      wait_for_activation:
        "Poczekaj do 24h na walidację konta ze strony naszych pracowników",
      contact_info: "Skontaktuj się z nami przez chat w godzinach 6:00 - 23:30",
      we_call_to_you: "Zadzwonimy do Ciebie",
      check_account_settings:
        "Sprawdz ustawienia swojego konta, dodaj dane do faktury jeżeli potrzebujesz",
      go_to_settings: "Przejdź do Ustawień",
    },

    invoices: {
      invoices: "Faktury",
      invoice_number: "Numer faktury",
      amount: "Kwota",
      doctor: "Lekarz",
      account_number: "Numer konta",
      date_of_issue: "Data wystawienia",
      date_of_transfer: "Data przelewu",
      download_all: "Pobierz wszystkie",
      download_invoice: "Pobierz fakturę",
      new: "Nowe",
      paid: "Opłacone",
      amount_to_pay: "Kwota do zapłaty",
      select_month: "Wybierz miesiąc z którego chcesz pobrać faktury",
      statuses: {
        new: "Nowa",
        paid: "Opłacona",
        to_send: "Do wysłania",
        all: "Wszystkie",
        sent: "Wysłane",
      },
      purchaser_name: "Zamawiający",
      order_number: "Numer zamówienia",
      date_of_order: "Data złożenia zamówienia",
      date_execution: "Data realizacji",
      invoice_issued: "Wystawiona",
      mark_as_issued: "Oznacz jako wystawioną",
      mark_as_issued_confirm:
        "Potwierdź, ze chcesz zmienic status faktury na wystawioną",
      csv: "csv",
      status: "status",
      select_file: "Wybierz plik",
      add_file: "Dodaj plik",
    },

    promotions: {
      name: "Nazwa kodu",
      type: "Typ kodu",
      description: "Opis kodu",
      stepper: {
        next: "Dalej",
        prev: "Wstecz",
        finish: "Zakończ",
      },
      discount_per_order: "Rabat na całe zamówienie",
      discount_on_product: "Rabat na każdy pasujący produkt",
      buy_to_receive: "Kup X aby otrzymać Y",
      newsletter_discount: "Zniżka na newsletter",
      numeric: "Numeryczny",
      alphanumeric: "Alfanumeryczny",
      alphabetical: "Alfabetyczny",
      discount: "Wysokość rabatu",
      discount_type: "Typ rabatu",
      is_personal_codes: "Kody personalne",
      what_examination_are_you_looking_for: "Jakiego badania szukasz?",
      which_products_does_this_promotion_apply_to:
        "Jakich produktów dotyczy ta promocja?",
      select_all_examinations: "Wybierz wszystkie badania",
      select_all_bundles: "Wybierz wszystkie pakiety",
      examination_name: "Nazwa badania",
      bundle_name: "Nazwa pakietu",
      limited_promotion: "Promocja ograniczona",
      number_of_promotions_for_the_code: "Ilość promocji dla kodu",
      infinitely_many_for_the_code: "Nieskończenie wiele dla kodu",
      number_of_promotions_for_the_user: "Ilość promocji dla użytkownika",
      base_amount: "Kwota bazowa",
      duration_of_the_promotion: "Czas trwania promocji",
      from: "Od",
      to: "Do",
      enter_the_code: "Wpisz kod",
      new_code: "Nowy kod",
    },

    doctor_card: {
      status: "Status",
      referral_number: "Numer zlecenia",
      total_price: "Cena",
      commission: "Wynagrodzenie",
      patient: "Pacjent",
      date_of_issue: "Data wystawienia",
      date_of_examination: "Data wykonania badania",
      city: "Miasto",
      street: "Ulica",
      postal_code: "Kod pocztowy",
    },
  },

  days: {
    monday: "Poniedziałek",
    tuesday: "Wtorek",
    wednesday: "Środa",
    thursday: "Czwartek",
    friday: "Piątek",
    saturday: "Sobota",
    sunday: "Niedziela",
  },

  auth: {
    create_account: "Załóż konto",
    enter_code: "Zweryfikuj numer telefonu",
    enter_code_below: " Wpisz ten kod poniżej",
    enter_new_password: "Podaj nowe hasło do twojego konta",
    email: "Adres e-mail",
    first_name: "Imię",
    go_back_to_login: "Wróć do logowania",
    have_account: "Masz już konto?",
    last_name: "Nazwisko",
    full_name: "Imię i nazwisko",
    logout: "Wyloguj",
    not_have_account: "Nie masz jeszcze konta?",
    not_receive_code: "Kod do mnie nie dotarł",
    not_remember_password: "Nie pamiętasz hasła?",
    password: "Hasło",
    password_confirm: "Powtórz hasło",
    password_remind: "Przypomnij hasło",
    password_reset: "Resetuj hasło",
    phone: "Nr telefonu",
    pwz: "Nr PWZ",
    register: "Zarejestruj się",
    reset: "Reset hasła",
    send_reset_link: "Na podany adres e-mail wyślemy link resetujący hasło",
    sent_reset_link: "Wysłaliśmy Ci SMS z kodem weryfikacyjnym pod numer",
    sent_reset_link_email:
      "Wysłaliśmy Ci wiadomość e-mail z linkiem do resetu hasła.",
    sent_reset_link_error:
      "Link został wysłany, odczekaj chwilę aby otrzymać nowy link.",
    reset_link_expired: "Twój link do resetu hasła wygasł",
    sign_in: "Zaloguj się",
    sign_in_short: "Zaloguj",
    sign_up: "Zarejestruj się",
    sms: "Kod SMS",
    specialist_panel: "do panelu specjalisty",
    patient_panel: "do panelu pacjenta",
    verify: "Zweryfikuj",
    pay_for_examinations: "aby opłacić badania",
    enter_email_and_password: "Wpisz swój email i hasło,",
    to_create_account: "aby utworzyć konto w portalu",
    enter_phone_number: "Wpisz swój numer telefonu",
    enter_pesel: "Wpisz swój pesel",
    login_by_pesel: "Zarejestruj się używając pesel",
    login_by_phone: "Zarejestruj się używając numeru telefonu",
    identity_card: "Nr dowodu",
    pesel: "Pesel",
    current_password: "Obecne hasło",
    set_password: "Ustaw hasło",
    salary: "Wynagrodzenie",
    patient_account: "do konta Pacjenta",
    country_code: "Numer kierunkowy",
    phone_number: "Numer telefonu",
    unselected_account_type: "Aby kontynuować musisz wybrać typ konta",
    account_type_for: "Potrzebujesz programu dla",
    account_type: {
      doctor: {
        title: "Lekarza lub specjalisty",
        description: "Konto indywidualne dla jednego lekarza",
      },
      clinic: {
        title: "Podmiot medyczny",
        description: "Konto idealne zarówno dla klinik i małych gabinetów",
      },
    },
    next_step: "Następny krok",
    back_to_homepage: "Wróć do strony głównej",
    your_office: "Twój gabinet",
    office_name: "Nazwa gabinetu",
    back: "Wróć",
    next: "Dalej",
    invalid_service_form_data: "Dane w formularzu są niepoprawne",
    hours_title: "Godziny przyjmowania pacjentów",
    hours_subtitle: "W jakich godzinach przyjmujesz pacjentów",
    hours_description: "Edytuj godziny przyjmowania pacjentów",
    hours_closed: "Zamknięte",
    hours: {
      from: "Od",
      to: "Do",
    },
    delete: "usuń",
    add_hour_range: "Dodaj kolejne godziny",
    registry_number: "numer księgi rejestrowej podmiotu znajdziesz",
    registry_number_link: "tutaj",
    clinic_name: "Nazwa przychodni/kliniki",
    clinic_description:
      "Podaj nazwę oraz specjalizacje medyczne jakie występują w placówce. Pomoże to w dodaniu usług jakie realizuje na następnym kroku",
    checkboxes: {
      information_obligation: "Obowiązku informacyjnym",
      agree: "Oświadczam, że zapoznałem/zapoznałam się i akceptuję",
      agree_marketing:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych, tj. adresu e-mail, w celu przesyłania newslettera drogą elektroniczną",
      agree_marketing_expand:
        " przez MedOnLive sp. z o.o, zgodnie z art. 10 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną (t.j. Dz. U. z 2017 r. poz. 1219). Oświadczam, iż zostałam/em poinformowany o moich uprawnieniach, o których szerzej mogę przeczytać w ",
      agree_contact:
        "Wyrażam zgodę na kontaktowanie się ze mną przez MedOnLive sp. z o.o",
      agree_contact_expand:
        ", w celu omówienia warunków umowy za pomocą telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących zgodnie z ustawą z dnia 16 lipca 2004 r. – Prawo telekomunikacyjne czyli m.in. za pomocą telefonu komórkowego",
      terms_of_service: "Regulamin serwisu",
      service: "serwisu",
      and: "oraz",
      privacy_policy: "Politykę prywatności",
      agree_processing_my_personal_data:
        "Wyrażam zgodę na przetwarzanie moich danych osobowych wskazanych w powyższym formularzu w celu założenia konta.",
      agree_processing_my_personal_data_expand:
        " Administratorem danych jest MedOnLive sp. z o.o. Oświadczam, że zostałam/em poinformowany o moich uprawnieniach, o których szerzej mogę przeczytać w",
      terms: "Regulamin",
    },
    commission_options: {
      d15p0: "15% dla lekarza, 0% dla pacjenta",
      d10p5: "10% dla lekarza, 5% dla pacjenta",
      d5p10: "5% dla lekarza, 10% dla pacjenta",
      d0p15: "0% dla lekarza, 15% dla pacjenta",
      other: "Inne",
    },
    birth_date: "Data urodzenia",
    day: "Dzień",
    month: "Miesiąc",
    year: "Rok",
    no_pesel: " Brak numeru PESEL",
    enter_pesel_number: "Podaj numer PESEL",
    enter_birth_date: "Podaj datę urodzenia",
    gender: {
      title: "Płeć",
      m: "Mężczyzna",
      f: "Kobieta",
    },
    roles_label: "Stanowisko",
    roles: {
      doctor: "Lekarz",
      clinic_owner: "Właściciel kliniki",
      clinic_worker: "Pracownik kliniki",
      clinic_it_specialist: "Informatyk",
    },
    required_name: "Nazwa gabinetu jest wymagana",
    choose_services_clinic: "Wybierz usługi które wykonuje placówka",
    choose_services_clinic_desc:
      "Poniżej dodaliśmy automatycznie najpopularniejsze usługi w twojej specjalizacji, możesz usunąć, edytować oraz dodać kolejne usługi.",
    hours_required: "Najpierw dodaj jakiś zakres godzin",
    invalid_hours: "Niepoprawny zakres godzin",
    overlapping_hours: "Pokrywający się zakres godzin",
  },

  cart: {
    selected_examinations: "Wybrane badania",
    no_examinations: "Nie wybrałeś jeszcze żadnych badań do zlecenia.",
    nurse_service: "Usługa pielęgniarska",
    covid_service: "Usługa pielęgniarska COVID",
    total: "Łącznie",
    your_commission: "Twoje wynagrodzenie",
    your_discount: "Zniżka",
    issue_referral: "Wystaw zlecenie",
    edit_referral: "Edytuj zlecenie",
    edit_referral_warning:
      "Edycja tego zlecenia spowoduje wystawienie nowego zlecenia i anulowanie obecnego zlecenia.",
    pay_referral: "Zapłać",
    details: "Szczegóły",
    selected_collection_point: "Wybrany Punkt Pobrań",
  },

  collection_facility: {
    collection_facility_title: "Wybierz Punkt Pobrań",
    collection_facility_text:
      "Ustaw dla którego punktu chcesz mieć pokazywany cennik badań laboratoryjnych. będziesz mógł go zmienić w każdej chwili w swoim profilu.",
    search_placeholder: "Miasto, ulica lub kod pocztowy",
    current_location_error:
      "Nie pozwolileś przeglądarce na pobranie lokalizacji. Spróbuj ponownie.",
    hide_list: "Ukryj listę",
    show_list: "Pokaż listę",
    show_filters: "Pokaż filtry",
    hide_filters: "Ukryj filtry",
    show_on_map: "Pokaż na mapie",
    set_the_route: "Wyznacz trasę",
  },

  dashboard: {
    inaccessible_facility:
      "Twój Punkt Pobrań jest nieaktywny bądź nie można w nim wykonać badań.",
    inaccessible_facility_btn: "Zmień Punkt Pobrań",
    commission_info:
      "Wynagrodzenie jest sumą kwot należnych do wypłaty za zlecenia zrealizowane",
    back_to_panel: "Wróć do panelu głównego",
    doctor: {
      register_title: "Twój gabinet już na Ciebie czeka",
      register_desc:
        "14 Dniowy okres próbny zaczyna się właśnie teraz. Wykorzystaj go w pełni uzupełniając swój profil, aby pacjencie z całej polski mogli umawiać się do Ciebie na wizyty online i nie tylko.",
      register_submit_button: "Wypełnij profil lekarza",
    },
    clinic: {
      register_title: "Twój gabinet już na Ciebie czeka",
      register_desc:
        "14 Dniowy okres próbny zaczyna się właśnie teraz. Wykorzystaj go w pełni uzupełniając swój profil, aby pacjencie z całej polski mogli umawiać się do Ciebie na wizyty online i nie tylko.",
      register_submit_button: "Wypełnij profil lekarza",
    },

    upcoming_visits: {
      header: "Nadchodzące wizyty",
      add_new: "Dodaj nową wizytę",
      no_visits: "Nie masz jeszcze żadnych wizyt, dodaj pierwszą wizytę",
    },

    quick_call: {
      header: "Przeprowadzasz szybką e-wizytę",
      info: "eWizyta bez rejestracji pacjenta w systemie",
      action: "Rozpocznij e-wizytę",
    },
  },

  doctor_status: {
    blocked: "Zablokowany",
    active: "Aktywny",
    inactive: "Nieaktywny",
    all: "Wszystkie",
  },

  referral_type: {
    home: "W domu",
    doctor: "Online",
    sport: "Sport",
    withoutSport: "Bez sportu",
    all: "Wszystkie",
  },

  empty_list: {
    referrals: "Lista zleceń jest pusta.",
    doctors: "Lista lekarzy jest pusta.",
    patients: "Lista pacjentów jest pusta.",
    invoices: "Lista faktur jest pusta.",
    no_data: "Brak danych",
  },

  error: {
    change_date: {
      date_after: {
        today: "Data musi być późniejsza niż obecna data.",
      },
      required: "Data jest wymagana.",
    },
    date_from: {
      date_after: {
        now: "Data od musi być późniejsza niż obecna data.",
      },
      conflict_meeting: "Data od jest w konflikcie z inną wizytą.",
    },
    date_to: {
      date_after: {
        date_from: "Data do musi być późniejsza niż data od.",
      },
    },
    response_error: "Niespodziewany błąd przy zapytaniu do serwera",
    response_validation_error:
      "Wysłane dane są nieprawidłowe. Sprawdź formularz i spróbuj ponownie.",
    keeper_id: {
      required_if_empty: {
        has_keeper:
          "Opiekun jest wymagany jeżeli zaznaczono że posiadasz swojego opiekuna.",
      },
    },
    accept_data_processing: {
      accepted: "Zgoda jest wymagana.",
    },
    agree_contact: {
      accepted: "Zgoda jest wymagana.",
    },
    gender: {
      required: "Płeć jest wymagana.",
    },
    accept_terms: {
      accepted: "Zgoda jest wymagana.",
    },
    accept_marketing: {
      accepted: "Zgoda jest wymagana.",
    },
    code: {
      required: "Kod sms jest wymagany.",
      incorrect: "Podany kod jest nieprawidłowy.",
    },
    email: {
      already_taken: "Podany email został już wykorzystany.",
      credentials_not_match: "Dane uwierzytelniające są nieprawidłowe.",
      email: "Email musi być poprawnym adresem email.",
      required: "Email jest wymagany.",
      selected_invalid: "Podany email nie istnieje w bazie.",
    },
    pesel: {
      required: "Pesel jest wymagany.",
      already_taken: "Podany pesel został już wykorzystany.",
      digits: "Pesel musi mieć długość 11.",
      invalid: "Niepoprawny numer pesel.",
      required_if_empty: {
        birth_date: "Pesel lub data urodzenia jest wymagana.",
      },
      required_when_not_present: {
        phone_number: "Numer telefonu lub pesel jest wymagany.",
        birth_date: "Pesel lub data urodzenia jest wymagana.",
      },
      incorrect: "Nie możemy odnaleźć użytkownika o podanym peselu.",
      birth_date_diffrent: "Data urodzenia oraz pesel różnią się od siebie",
      invalid_user_exists:
        "Istnieje użytkownik którego pesel i nr telefonu są inne niż podane.",
    },
    birth_date: {
      required: "Data urodzenia jest wymagana.",
      required_if_empty: {
        pesel: "Pesel lub data urodzenia jest wymagana.",
      },
      required_when_not_present: {
        phone_number: "Numer telefonu lub pesel jest wymagany.",
        pesel: "Pesel lub data urodzenia jest wymagana.",
      },
      must_be_date_after_or_equal:
        "Data urodzenia musi być większa lub równa dacie 01.01.1900.",
      must_be_a_date_before: "Nie można wybrać takiej daty urodzenia.",
      invalid_date: "Data urodzenia nie jest poprawną datą.",
      incorrect: "Data urodzenia oraz pesel różnią się od siebie",
      no_adult: "Data urodzenia dotyczy osoby dorosłej po 17 roku życia",
      invalid_user_exists:
        "Istnieje użytkownik którego data urodzenia i nr telefonu są inne niż podane.",
    },
    patient_age: {
      underage:
        "Przepraszamy na chwile obecną jest możliwość wystawienia zleceń wyłącznie na osoby pełnoletnie",
    },
    pesel_invalid: "Pesel dotyczy osoby dorosłej po 17 roku życia",
    first_name: {
      required: "Imię jest wymagane.",
    },
    last_name: {
      required: "Nazwisko jest wymagane.",
    },
    main_medical_category_id: {
      required: "Proszę wybrać kategorie.",
    },
    current_password: {
      required: "Obecne hasło jest wymagane.",
      at_least_characters: "Obecne hasło musi mieć co najmniej 8 znaków.",
      invalid_format:
        "Obecne hasło musi zawierać przynajmniej jedną małą literę, jedną dużą literę i jedną cyfrę.",
      incorrect: "Obecne hasło jest nieprawidłowe.",
    },
    password: {
      required: "Hasło jest wymagane.",
      at_least_characters: "Hasło musi mieć co najmniej 8 znaków.",
      invalid_format:
        "Hasło musi zawierać przynajmniej jedną małą literę, jedną dużą literę i jedną cyfrę.",
    },
    password_confirm: {
      required: "Potwierdzenie hasła jest wymagane.",
      must_match: "Hasło i potwierdzenie hasła muszą być takie same.",
    },
    phone_number: {
      already_taken: "Podany numer telefonu został już wykorzystany.",
      required: "Nr telefonu jest wymagany.",
      digits: "Nr telefonu musi mieć długość 9.",
      incorrect: "Nie możemy odnaleźć użytkownika o podanym nr telefonu.",
      choose_country: "Wybierz kraj",
      required_when_not_present: {
        pesel: "Numer telefonu lub pesel jest wymagany.",
      },
      accepted: "Błędny numer telefonu",
    },
    national_number: {
      required: "Nr telefonu jest wymagany",
    },
    phone_is_valid: {
      accepted: "Niepoprawny numeru telefonu.",
    },
    pwz: {
      required: "Pwz jest wymagane.",
    },
    company_name: {
      required: "Nazwa firmy / przychodni jest wymagana.",
    },
    nip: {
      required: "Nip jest wymagany.",
      digits: "Nip musi mieć długość 10.",
    },
    street: {
      required: "Ulica jest wymagana.",
    },
    house_number: {
      required: "Numer budynku jest wymagana.",
    },
    postal_code: {
      required: "Kod pocztowy jest wymagany.",
    },
    city: {
      required: "Miejscowość jest wymagana.",
    },
    account_number: {
      required: "Numer rachunku bankowego jest wymagany.",
      invalid: "Numer rachunku bankowego jest niepoprawny.",
      invalid_lenght: "Numer rachunku bankowego powinien posiadać 30 znaków.",
      invalid_checksum: "Numer rachunku bankowego jest niepoprawny",
    },
    agree1: {
      accepted: "Zgoda jest wymagana.",
    },
    identity_card: {
      required: "Nr dowodu jest wymagany.",
    },
    title: {
      required: "Tytuł jest wymagany.",
    },
    message: {
      required: "Treść wiadomości jest wymagana.",
    },
    commission_option: {
      required: "Opcja wynagodzenia jest wymagana.",
      selected_invalid: "Opcja wynagrodzenia musi być jedną z opcji powyżej.",
    },
    is_verify: "Konto z podanym numerem telefonu już istnieje.",
    name: {
      required: "Nazwa jest wymagana.",
      distinct: "Nazwa musi być unikalna.",
      already_taken: "Podana nazwa została użyta",
    },
    start_date: {
      invalid_date: "Data jest nieprawidłowa",
    },
    end_date: {
      required: "Data zakończenia jest wymagana.",
      invalid_date: "Data jest nieprawidłowa",
      date_after: {
        change_date: "Data musi być późniejsza niż data początkowa.",
      },
    },
    date: {
      at_least_characters: "Nie można wpisać starszego roku niż 2022",
    },
    register_book_no: {
      must_not_be_greater_than_12:
        "Numer rejestru podmiotu może mieć maksymalnie 12 znaków",
    },
    promotions: {
      name: {
        required: "Nazwa kodu jest wymagana.",
      },
      description: {
        required: "Opis kodu jest wymagany.",
      },
      type: {
        required: "Typ kodu jest wymagany.",
      },
      discount: {
        required: "Wysokość rabatu jest wymagana.",
        maxValue: "Wysokość rabatu nie może przekraczać 100%",
        minValue: "Wysokość rabatu nie być mniejsza od 0",
      },
      type_discount: {
        required: "Typ rabatu jest wymagany.",
      },
      use_limit_per_user: {
        required: "Ilość promocja dla użytkownika jest wymagana.",
      },
      minimum_order_amount: {
        required: "Kwota bazowa jest wymagana.",
      },
      start_date: {
        beforeEndDate:
          "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
      },
      code_save_types: {
        required: "Sposób generowania kodu jest wymagany.",
      },
      file: {
        required: "Import pliku jest wymagany.",
      },
      code: {
        required: "Kod jest wymagany.",
      },
      amount_codes: {
        required: "Liczba kodów jest wymagana.",
      },
      length_limit: {
        required: "Ilość znaków kodu jest wymagana.",
      },
      code_type: {
        required: "Format kodu jest wymagany.",
      },
      sufix: {
        required: "Sufix kodu jest wymagany.",
      },
      prefix: {
        required: "Prefix kodu jest wymagany.",
      },
    },
    invalid_form_data:
      "Niepoprawne dane formularza, popraw je żeby przejść dalej",
    form: {
      required: {
        first_name: "Imię jest wymagane",
        last_name: "Nazwisko jest wymagane",
        pwz: "Pwz jest wymagane",
        main_medical_category_id: "Specjalizacja jest wymagana",
        email: "Email jest wymagany",
        phone_number: "Numer telefonu jest wymagany",
        password: "Hasło jest wymagane",
        password_confirm: "Powtórzenie hasła jest wymagane",
        checkbox: "Zgoda jest wymagana",
        role: "Stanowisko jest wymagane",
        register_book_no: "Numer rejestru jest wymagany",
      },
      max: {
        register_book_no:
          "Numer rejestru podmiotu powinien mieć maksymalnie 12 znaków",
      },
      invalid: {
        email: "Niepoprawny adres email",
      },
    },
  },

  form: {
    label: {
      time_period: "Długość trwania",
      meeting_interval: "Wybierz z listy",
    },
  },

  error_page: {
    ups: "Ups, coś poszło nie tak. Poczekaj chwilę lub spróbuj odświeżyć stronę.",
    refresh: "Odśwież",
  },

  examinations: {
    package: "pakiet",
    no_examinations: "Brak badań.",
    no_packages: "Brak pakietów.",
  },

  search: {
    examinations: "szukane badania",
    packages: "szukane pakiety",
    what_kind_of_visit_are_you_looking_for: "Jakiej wizyty szukasz?",
  },

  filters: {
    salary: "Wynagrodzenie",
    type: "Typ",
    status: "Status",
    referral_id: "ID zlecenia",
    referral_number: "Numer zlecenia",
    patient: "Pacjent",
    doctor: "Lekarz",
    price: "Cena",
    commission: "Wynagrodzenie",
    date_of_issue: "Data wystawienia",
    date: "Data",
    cost: "Koszt badania",
    company_name: "Nazwa przychodni",
    patient_discount_percent: "Procent rabatu",
    number_of_tests: "Ilość testów",
  },

  patient_discount_percent: {
    zero: "0 %",
    five: "5 %",
    ten: "10 %",
    fifteen: "15 %",
    all: "Wszystkie",
  },

  homepage: {
    doctor: "Lekarz",
    patient: "Pacjent",
    admin: "Administrator",
    cms: "CMS",
    shop: "Sklep",
    faq: "FAQ",
    about_us: "O nas",
    contact: "Kontakt",
    catalog_of_examinations: "Katalog badań",
    cart: "Koszyk",
    my_referrals: "Moje zlecenia",
    discount_1: "Do",
    discount_2: "Na wszystkie pakiety badań",
    discount_3: "Sprawdź",
    highest_quality_research:
      "Wykonaj najwyższej jakości badania w całej Polsce",
    choose_from:
      "Wybierz spośród ponad 3500 badań, 68 kategorii badań i pakietów.",
    join_special_actions:
      "Dołącz do akcji specjalnych, korzystaj z promocji, twórz pakiety własne oraz używaj konta pacjenta z historią i analizami wyników badań.",
    shortcuts: "Na skróty",
    morphology: "Morfologia",
    glucose: "Glukoza",
    cpr: "CRP",
    creatynine: "Kreatynina",
    potassium: "Potas",
    iron: "Żelazo",
    mercury_in_the_blood: "Rtęć we krwi",
    collection_points_1: "Ponad",
    collection_points_2: "Punktów Pobrań",
    research_every_year_1: "Ponad",
    research_every_year_2: "mln",
    research_every_year_3: "badań rocznie",
    years_on_the_market_1: "Ponad",
    years_on_the_market_2: "lat",
    years_on_the_market_3: "na rynku",
    what_examination_are_you_looking_for: "Jakiego badania szukasz?",
  },

  layouts: {
    issue_referral: "Wystaw zlecenie",
    referral_history: "Historia zleceń",
    patient_list: "Lista pacjentów",
    main_page: "Strona główna",
    examintons_list: "Katalog badań",
    own_packages: "Pakiety własne",
  },

  medical_categories: {
    allergist: "Alergolog",
    pediatric_allergist: "Alergolog dziecięcy",
    andrologist: "Androlog",
    anesthesiologist: "Anestezjolog",
    angio_surgeon: "Angiochirurg",
    angiologist: "Angiolog",
    audiologist: "Audiolog",
    bariatra: "Bariatra",
    forensic_expert: "Biegły Sądowy",
    surgeon: "Chirurg",
    pediatric_surgeon: "Chirurg dziecięcy",
    thoracic_surgeon: "Chirurg klatki piersiowej",
    vascular_surgeon: "Chirurg naczyniowy",
    plastic_surgeon: "Chirurg plastyczny",
    dental_surgeon: "Chirurg stomatologiczny",
    maxillofacial_surgeon: "Chirurg Szczękowo-Twarzowy",
    dermatologist: "Dermatolog",
    pediatric_dermatologist: "Dermatolog Dziecięcy",
    diabetologist: "Diabetolog",
    pediatric_diabetologist: "Diabetolog Dziecięcy",
    diagnostic: "Diagnostyk",
    dietician: "Dietetyk",
    endocrinologist: "Endokrynolog",
    pediatric_endocrinologist: "Endokrynolog Dziecięcy",
    physiatrist: "Fizjoterapeuta",
    pediatric_physiatrist: "Fizjoterapeuta Dziecięcy",
    phlebologist: "Flebolog",
    gastrologist: "Gastrolog",
    pediatric_gastrologist: "Gastrolog Dziecięcy",
    geneticist: "Genetyk",
    geriatrician: "Geriatra",
    gynecologist: "Ginekolog",
    pediatric_gynecologist: "Ginekolog dziecięcy",
    hematologist: "Hematolog",
    pediatric_hematologist: "Hematolog dziecięcy",
    hepatologist: "Hepatolog",
    dental_hygienist: "Higienistka stomatologiczna",
    hypertensiologist: "Hipertensjolog",
    histopathologist: "Histopatolog",
    immunologist: "Immunolog",
    internist: "Internista",
    cardiac_surgeon: "Kardiochirurg",
    cardiologist: "Kardiolog",
    pediatric_cardiologist: "Kardiolog dziecięcy",
    laryngologist: "Laryngolog",
    pediatric_laryngologist: "Laryngolog dziecięcy",
    infectious_diseases_physician: "Lekarz Chorób Zakaźnych",
    occupational_medicine_physician: "Lekarz Medycyny Pracy",
    doctor_of_emergency_medicine: "Lekarz Medycyny Ratunkowej",
    physician_of_medical_rehabilitation: "Lekarz Rehabilitacji Medycznej",
    family_doctor: "Lekarz rodzinny",
    sports_doctor: "Lekarz sportowy",
    sports_medicine_physician: "Lekarz medycyny sportowej",
    a_doctor_in_the_process_of_specialization: "Lekarz w trakcie specjalizacji",
    doctor_without_specialization: "Lekarz bez specjalizacji",
    logopedist: "Logopeda",
    nephrologist: "Nefrolog",
    pediatric_nephrologist: "Nefrolog dziecięcy",
    neonatologist: "Neonatolog",
    neurosurgeon: "Neurochirurg",
    pediatric_neurosurgeon: "Neurochirurg dziecięcy",
    neurologist: "Neurolog",
    pediatric_neurologist: "Neurolog dziecięcy",
    ophthalmologist: "Okulista",
    pediatric_ophthalmologist: "Okulista dziecięcy",
    oncologist: "Onkolog",
    pediatric_oncologist: "Onkolog dziecięcy",
    optometrist: "Optometrysta",
    orthodontist: "Ortodonta",
    orthopedist: "Ortopeda",
    pediatric_orthopedist: "Ortopeda dziecięcy",
    orthoptist: "Ortoptysta",
    osteopath: "Osteopata",
    pathomorphologist: "Patomorfolog",
    pediatrician: "Pediatra",
    perinatologist: "Perinatolog",
    nurse: "Pielęgniarka",
    obstetrician: "Położnik",
    midwife: "Położna",
    proctologist: "Proktolog",
    prosthetist: "Protetyk",
    psychiatrist: "Psychiatra",
    child_psychiatrist: "Psychiatra dziecięcy",
    psychologist: "Psycholog",
    child_psychologist: "Psycholog dziecięcy",
    psycho_oncologist: "Psychoonkolog",
    psychotherapist: "Psychoterapeuta",
    psychotraumatologist: "Psychotraumatolog",
    pulmonologist: "Pulmonolog",
    pediatric_pulmonologist: "Pulmonolog dziecięcy",
    radiologist: "Radiolog",
    radiation_therapist: "Radioterapeuta",
    rheumatologist: "Reumatolog",
    pediatric_rheumatologist: "Reumatolog dziecięcy",
    sexologist: "Seksuolog",
    specialist_in_aesthetic_medicine: "Specjalista Medycyny Estetycznej",
    dentist: "Stomatolog",
    pediatric_dentist: "Stomatolog dziecięcy",
    transplantologist: "Transplantolog",
    coach: "Trener",
    ultrasonograph: "Ultrasonograf",
    urologist: "Urolog",
    pediatric_urologist: "Urolog dziecięcy",
    venereologist: "Wenerolog",
    main_category: "Specjalizacja",
    list: "Specjalizacje",
    all: "Wszystkie",
    bariatrician: "Bariatra",
    cardiothoracic_surgeon: "Chirurg Klatki Piersiowej",
    diagnostician: "Diagnostyk",
    physiotherapist: "Fizjoterapeuta",
    pediatric_physiotherapist: "Fizjoterapeuta Dziecięcy",
    gastroenterologist: "Gastrolog",
    pediatric_gastroenterologist: "Gastrolog Dziecięcy",
    hypertension_specialist: "Hipertensjolog",
    infectious_disease_specialist: "Lekarz Chorób Zakaźnych",
    occupational_physician: "Lekarz Medycyny Pracy",
    emergency_physician: "Lekarz Medycyny Ratunkowej",
    rehabilitation_medicine_specialist: "Lekarz Rehabilitacji Medycznej",
    sports_physician: "Lekarz sportowy",
    registrar: "Lekarz w trakcie specjalizacji",
    doctor: "Lekarz bez specjalizacji",
    speech_therapist: "Logopeda",
    orthotist: "Protetyk",
    pediatric_psychiatrist: "Psychiatra Dziecięcy",
    pediatric_psychologist: "Psycholog Dziecięcy",
    "psycho-oncologist": "Psychoonkolog",
    radiotherapist: "Radioterapeuta",
    medical_esthetician: "Specjalista Medycyny Estetycznej",
    stomatologist: "Stomatolog",
    pediatric_stomatologist: "Stomatolog Dziecięcy",
    transplant_surgeon: "Transplantolog",
    trainer: "Trener",
    ultrasonographer: "Ultrasonograf",
  },

  messages: {
    code: {
      resend: "Kod został wysłany ponownie.",
      resend_error: "Wystąpił błąd podczas wysyłania kodu.",
    },
    edit: {
      success: "Zmiany zostały zapisane.",
      failure: "Wystąpił błąd. Zmiany nie zostały zapisane.",
    },
    cancel_referral: {
      success: "Zlecone badania zostały anulowane.",
      failure: "Wystąpił błąd. Zlecone badania nie zostały anulowane.",
    },
    edit_amd_send_seferral: {
      success: "Zmiany zostały zapisane oraz ponownie wysłano zlecenie.",
    },
    save: {
      success: "Zapisano pomyślnie.",
      failure: "Wystąpił błąd. Nie udało się zapisać.",
    },
    sms: {
      success: "Sms został wysłany ponownie.",
      failure: "Wystąpił błąd. Sms nie został wysłany ponownie.",
    },
    send: {
      failure: "Wystąpił błąd. Nie udało się wysłać wiadomości.",
    },
    payment_token: {
      failure:
        "Wystąpił błąd. Spróbuj ponownie albo skontaktuj się z administratorem.",
    },
    permission: {
      failure: "Nie można wykonać.",
      forbidden:
        "Konto jest nieaktywne, skontaktuj się z biurem obsługi klienta.",
    },
    download: {
      failure: "Wystąpił błąd podczas pobierania pliku.",
      no_invoice: "Brak faktur z wybranego miesiąca.",
      no_files: "Nie znaleziono plików do pobrania.",
    },
    test_to_describe: {
      save_as_a_draft: {
        success: "Pomyślnie zapisano jako wersję roboczą.",
        failure: "Wystąpił błąd. Opis nie został zapisany jako wersja robocza.",
      },
      send_to_patient: {
        success: "Pomyślnie wysłane do pacjenta.",
        failure: "Wystąpił błąd. Opis nie został wysłany do pacjenta.",
      },
    },
    prev_patient: {
      not_found: "Nie znaleziono następnego pacjenta",
    },
    next_patient: {
      not_found: "Nie znaleziono poprzedniego pacjenta",
    },
    user: {
      inactive: "Konto użytkownika nie zostało jeszcze aktywowane",
    },
  },

  not_found_page: {
    error: "Błąd",
    not_found: "Nie znaleziono strony",
    go_back: "Wróć na stronę główną",
  },

  pages: {
    account: "Ustawienia konta",
    history_orders: "Historia zleconych badań",
    my_settlements: "Moje rozliczenia",
    doctors: "Lekarze",
    referrals: "Zlecenia",
    invoices: "Faktury",
    your_referrals: "Twoje zlecenia",
    clientinvoices: "Faktury klientów",
    raports: "Raporty",
    referralErrors: "Logi błędów",
    promotions: "Promocje",
  },

  patients: {
    list: {
      title: "Pacjenci",
      search_patient: "Wpisz imię, nazwisko, pesel lub nr telefonu",
      columns: {
        fullName: "Imię i nazwisko",
        pesel: "PESEL",
        phone: "Telefon",
        upcoming_visits: "Nadchodzące wizyty",
      },
      sort: "Sortuj",
      action_buttons: {
        patient_cart: "Karta pacjenta",
        add_patient: "Dodaj pacjenta",
      },
    },
    routes: {
      patient_details: "Dane pacjenta",
      scheduled_visits: "Zaplanowane wizyty",
      visits_history: "Historia wizyt",
      examinations_history: "Historia badań",
    },
    card: {
      action_buttons: {
        patient_cart: "Karta pacjenta",
      },
      details: {
        title: "Dane pacjenta",
        personal_data: "Dane osobowe",
        contact_data: "Dane kontaktowe",
        name_and_surname: "Imię i nazwisko",
        sex: "Płeć",
        pesel: "PESEL",
        birth_date: "Data urodzenia",
        phone_number: "Numer telefonu",
        email: "Adres e-mail",
      },
      upcoming_visits: {
        title: "Zaplanowane wizyty",
        columns: {
          date_and_time: "Data i godzina",
          service: "Usługa",
          visit_type: "Typ wizyty",
        },
        action_buttons: {
          start_visit: "Rozpocznij wizytę",
        },
        sort: "Sortuj",
        empty_list: "Brak zaplanowanych wizyt",
        visit_type: {
          phone: "Teleporada",
          "phone-call": "Teleporada",
          video: "Online",
          null: "-",
        },
        start_visit: "Rozpocznij wizytę",
        filters: {
          service: "Usługa",
        },
      },
      visits_history: {
        title: "Historia wizyt",
        columns: {
          date: "Data",
          hour: "Godzina",
          patient: "Pacjent",
          service: "Usługa",
          visit_type: "Typ wizyty",
          state: "Status",
          examinations_issued: "Wystawione badania",
        },
        empty_list: "Brak zaplanowanych wizyt",
        visit_type: {
          phone: "Teleporada",
          "phone-call": "Teleporada",
          video: "Online",
          offline: "W gabinecie",
          null: "-",
        },
      },
      examinations_history: {
        title: "Historia badań",
        sort: "Sortuj",
        filters: {
          referral_id: "ID zlecenia",
          date_of_issue: "Data wystawienia",
          referral_status: "Status",
          price: "Koszt badania",
        },
        columns: {
          referral_id: "ID zlecenia",
          date_of_issue: "Data wystawienia",
          facility_street: "Punkt pobrań - ulica",
          facility_city: "Punkt pobrań - miasto",
          facility_postal_code: "Kod pocztowy",
          status: "Status",
          examinations_count: "Ilość badań",
          examinations_cost: "Koszt badań",
        },
        goToReferral: "Zobacz zlecenie",
      },
    },
    layout: {
      title: "Karta pacjenta",
      pesel: "PESEL",
      action_buttons: {
        add_visit: "Dodaj wizytę",
      },
    },

    edit_patient: "Edytuj wybranego pacjenta",
    edit: "Edytuj pacjenta",
    no_patients: "Nie posiadasz jeszcze pacjentów.",
    patient_in_system_assign_to_another_doc:
      "Pacjent znajduje się już w naszym systemie",
    request_access_to_historical_test_results:
      "W celu przeprowadzenia lepszej diagnostyki poproś o dostęp do historycznych wyników badań",
  },

  referral_status: {
    doctor: {
      issued: "Wystawione",
      paid: "Opłacone",
      canceled: "Anulowane",
      completed: "Zrealizowane",
      to_describe: "Do opisania",
      described: "Opisane",
      all: "Wszystkie",
    },
    admin: {
      issued: "Wystawione",
      paid: "Opłacone",
      canceled: "Anulowane",
      completed: "Zrealizowane",
      to_describe: "Do opisania",
      described: "Opisane",
      all: "Wszystkie",
      visit_data_missing: "Zamówienie nie posiada wybranej daty wizyty",
    },
    patient: {
      issued: "Nowe",
      paid: "Opłacone",
      canceled: "Anulowane",
      completed: "Zrealizowane",
      to_describe: "Oczekujące na opis",
      described: "Opisane",
    },
  },

  own_packages: {
    examination_details: "Szczegóły badania",
    package_details: "Szczegóły pakietu",
    add_to_own_package: "Dodaj do pakietu własnego",
    create_first_own_package:
      "Utwórz swój pierwszy pakiet własny wpisując poniżej jego nazwę.",
    edit_own_package: "Edycja nazwy pakietu własnego",
    your_own_packages: "Twoje pakiety własne",
    add_to_new_own_package: "Dodaj do nowego pakietu własnego",
    create_own_package: "Stwórz pakiet własny",
    create_own_examination_package: "Stwórz własny pakiet badań",
    other_examinations: "Pozostałe badania",
    examination_packages: "Pakiety badań",
    own_packages: "Pakiety własne",
    create_first_own_examination_package: "Stwórz swój pierwszy pakiet badań",
    thanks_to_own_packages: "Dzięki pakietom własnym",
    faster_access:
      "Będziesz miał szybszy dostęp do badań których często szukasz",
    shorter_working_time: "Skrócisz czas swojej pracy i wystawiania zleceń",
    edit_package_name: "Edytuj nazwę pakietu",
    delete_package: "Usuń pakiet",
    add_to_cart: "Dodaj do koszyka",
    add_to_cart_selected: "Dodaj wybrane badania",
    add_new_own_package: "Dodaj nowy pakiet własny",
    update_own_package: "Edytuj pakiet własny",
    name_own_package: "Nazwa pakietu własnego",
    delete_new_own_package: "Usuń pakiet własny",
    delete_new_own_package_confirm: "Czy na pewno chcesz usunąć pakiet",
    examinations: "badania",
    examinations_counter: "badań",
    add_examinations_to_package: "Dodaj kolejne badanie do pakietu",
    no_examinations_in_package_1:
      "Nie dodałeś jeszcze żadnych badań do swojego pakietu",
    no_examinations_in_package_2: "Jak dodać badania do pakietu własnego?",
    no_examinations_in_package_3:
      "Przy każdym badaniu (pod jego nazwą), znajduje się niebieska gwiazdka z linkiem, która umożliwia dodania wybranego badania do pakietu własnego",
    no_examinations_in_package_4:
      "Kliknij w nią i wybierz do którego pakietu chcesz dodać badanie. Pamiętaj, że możesz stworzyć nieskończenie wiele pakietów, warto tylko nazywać je w zrozumiały i charakterystyczny dla Ciebie sposób",
    no_examinations_in_package_5: "Przejdź do listy z wyborem badań",
  },

  referrals: {
    add_visit_to_referral: "Dodaj wizytę online",
    cancel_issued_referral: "Anuluj zlecone badania",
    make_a_referral: "Wystaw badania",
    receive_VAT_invoice: "Chcę otrzymać fakturę VAT",
    to_receive_an_invoice:
      "Aby otrzymać fakturę prosimy kontaktować się na adres email:",
    enter_study_name: "Wpisz nazwę badania",
    referral: "Zlecenie",
    number_short: "nr",
    examinations: "badania",
    date_of_issue: "data wystawienia",
    date_of_test: "data wykonania badań",
    exact_price: "Dokładną cenę poznasz po wyborze Punktu Pobrań",
    doctor: "lekarz",
    number: "Zlecenie nr",
    issued_on: "Wystawiono dnia",
    see_results: "Zobacz wyniki badań",
    commissioned_examinations: "Zlecone badania",
    patient: "Pacjent",
    phone_number: "Nr telefonu",
    pesel: "Pesel",
    payment: "Płatność",
    commission: "Twoje wynagrodzenie",
    add_or_choose_patient:
      "Uzupełnij dane nowego pacjenta lub znajdź na liście swoich pacjentów",
    issue_referrals: "Wystaw zlecenie",
    patient_list: "Lista pacjentów",
    my_patient_list: "Lista moich pacjentów",
    choose_patient: "Wybierz pacjenta z listy",
    full_name: "Imię i nazwisko",
    search_patient: "Wpisz imię, nazwisko, pesel lub nr telefonu",
    search_referral_patient: "Wpisz imię lub nazwisko",
    send_sms_again: "Wyślij sms ponownie",
    edit_issued_referral: "Edytuj zlecone badania",
    issued_referral_text_part1:
      "Wystawiłeś zlecenie. Wysłaliśmy SMS do pacjenta z instrukcją realizacji zlecenia.",
    issued_referral_text_part2:
      "Otrzymasz wynagrodzenie, kiedy pacjent opłaci zlecenie.",
    referral_for_examination: "Zlecenie badań laboratoryjnych",
    referral_for_examination_text:
      "Wydrukowane zlecenie Twój pacjent może zrealizować bezpośrednio w punkcie pobrań. Brak możliwości płatności w punkcie. Płatność tylko ONLINE.",
    print_referral: "Drukuj zlecenie",
    collection_facilities: "Punkty Pobrań",
    collection_facilities_text:
      "Sprawdź, w którym Punkcie Pobrań Twój pacjent może zrealizować zlecenie",
    see_collection_facilities: "Zobacz Punkty Pobrań",
    examination_findings: "Wyniki badań",
    examination_findings_text:
      "Wyniki badań będą dostępne po zrealizowaniu zlecenia",
    unavailable: "Niedostępne",
    waiting_for_payment: "Oczekiwanie na płatność",
    waiting_for_commissions: "Oczekiwanie na wynagrodzenie",
    price_online_payment: "Cena przy płatności internetowej w serwisie",
    price_facility_payment: "Cena przy płatności w punkcie pobrań",
    commission_after_purchase:
      "Wynagrodzenie naliczy się po wykupieniu zlecenia przez pacjenta",
    no_referrals: "Nie posiadasz wystawionych zleceń.",
    issue_referral: "Wystaw zlecenie na badanie",
    popular_examinations: "Najczęściej wybierane badania",
    package: "pakiet",
    added: "Dodano",
    number_of_referrals: "Ilość zleceń",
    average_number_of_referrals: "Śr. ilość zleceń",
    average_price_of_referral: "Śr. cena zlecenia",
    top_doctors: "Lekarze, którzy wystawili zlecenia na największą sumę:",
    your_facility: "Twój Punkt Pobrań",
    choose_examinations: "Dobierz badania",
    additionally_examinations:
      "Jeżeli chcesz, możesz dodatkowo wykonać inne badania",
    ordered_examinations: "Zlecone badania",
    change: "Zmień dane i wyślij zlecenie ponownie",

    tabs: {
      packages: "Pakiety",
      examinations: "Badania",
    },

    table: {
      id: "ID zlecenia",
      date: "Data wystawienia",
      full_name: "Imię i nazwisko",
      full_patient_name: "Imię i Nazwisko Pacjenta",
      identity_card: "Nr dowodu",
      status: "Status",
      phone: "Numer telefonu",
      number_of_examinations: "Ilość badań",
      commission: "Twoje wynagrodzenie",
      show: "Zobacz zlecenie",
      show_patient: "Zobacz pacjenta",
      code: "Kod pocztowy",
      city: "Miasto",
      street: "Ulica",
      price: "Koszt badań",
      cost: "Koszt badania",
      pesel: "Pesel",
      patient_discount_percent: "Rabat pacjenta",
      patient_discount: "Rabat pacjenta",
      doctor_commission_percent: "Twoje wynagrodzenie",
      provision_percent: "% prowizji",
      provision: "Prowizja",
    },
  },

  results: {
    download_pdf: "Pobierz wyniki w PDF",
    back_to_referral: "Powrót do zlecenia",
    choose_examination: "Wybierz badanie, żeby wyświetlić wyniki",

    description_titles: {
      profile: "Profil",
      follow_up_plan: "Plan dalszych działań",
      lifestyle_modifications: "Modyfikacje stylu życia",
      results: "Wyniki",
      health_risk_assessment: "Ocena ryzyka dla zdrowia",
      summarize_for_patient_communication: "Uwagi lekarza",
    },
  },

  select_time: {
    current_month: "Bieżący miesiąc",
    previous_month: "Poprzedni miesiąc",
    last_90_days: "Ostatnie 90 dni",
    last_6_months: "Ostatnie 6 miesięcy",
    current_year: "Bieżący rok",
    selected_from: "Wybierz z kalendarza",
  },

  titles: {
    your_finances: "Twoje finanse",
    your_stats: "Twoje statystyki",
    stats: "Statystyki",
    top_doctors: "Top lekarze",
  },

  your_finances: {
    to_pay: "Do wypłaty",
  },

  your_referrals: {
    see_results: "Zobacz wyniki badań",
    pay: "Opłać badania",
    see_summary: "Zobacz podsumowanie",
    just_paid: "Opłaciłeś już to zlecenie.",
    go_to_facility: "Udaj się do Punktu Pobrań, żeby wykonać badania.",
  },
  documents: {
    terms: "Regulamin serwisu",
    privacy_policy: "Polityka prywatności",
  },

  your_settlements: {
    user_full_name: "Imię i nazwisko",
    address: "Adres",
    billing_data: "Dane do faktury",
    edit_billing_data: "Edytuj dane do faktury",
    my_settlements: "Moje rozliczenia",
    verify_data_title: "Zweryfikuj swoje dane",
    verify_data_text:
      "Podaj dane do rozliczeń, aby móc rozliczyć wynagrodzenie od wystawionych zleceń",
    company_data_title: "Dane firmy",
    company_name: "Nazwa firmy / przychodni",
    nip: "NIP",
    free_from_vat_title: "Czy jesteś zwolniony z VAT?",
    free_from_vat:
      "Oświadczam, iż przysługuje mi prawo do zwolnienia podmiotowego przewidzianego w art. 113 ust. 1 ustawy o VAT",
    address_title: "Adres",
    street: "Ulica",
    house_number: "Numer budynku",
    flat_number: "Numer lokalu",
    postal_code: "Kod pocztowy",
    city: "Miejscowość",
    account_number_title: "Numer rachunku bankowego",
    account_number: "Numer rachunku bankowego",
    verify_account: "Zweryfikuj konto",
    your_invoices: "Twoje faktury",

    checkboxes: {
      check_all: "Zaznacz wszystkie",
      agree_terms: "Oświadczam, iż przeczytałem i akceptuję",
      terms: "regulamin",
      marketing:
        "Wyrażam zgodę na przesyłanie informacji handlowych i marketingowych, za pośrednictwem środków komunikacji elektronicznej.",
      agree3:
        "Donec dolor mi, interdum vel arcu vel, gravida sollicitudin est. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed accumsan dui et sollicitudin porttitor",
      agree4:
        "Donec sed lacus leo. Fusce fermentum sem sed odio luctus, eu sollicitudin massa elementum. Maecenas pellentesque ligula libero, vel condimentum sem lobortis et",
    },

    invoice: {
      date: "Data",
      number: "Numer faktury",
      amount: "Kwota",
      download: "Pobierz fakture",
    },
  },
  share: {
    patient_examinations: "Badania pacjenta",
    approvals: "Zgody",
    ask_for_access: "Poproś o dostęp do wyników badań",
    ask_was_send: "Prośba o dostęp do wyników badań została wysłana.",
    have_access: "Masz dostęp do wyników badań pacjenta.",
  },

  your_stats: {
    issued_referrals: "Wystawione zlecenia",
    paid_referrals: "Opłacone zlecenia",
    completed_referrals: "Zrealizowane zlecenia",
    canceled_referrals: "Anulowane zlecenia",
    commission: "Wynagrodzenie",
    cost: "Koszt badań",
  },
  payment: {
    made: "Platność zrealizowana.",
    canceled: "Płatność anulowana.",
    advance: "Oczekiwanie na potwierdzenie płatności.",
    returned: "Płatność zwrócona.",
    go_to_dashboard: "Przejdź do panelu głównego",
    retry_payment: "Ponów płatność",
  },
  category: {
    bundles_categories: "kategorie pakietów",
    examinations_categories: "kategorie badań",
  },

  feature: {
    patient_own_packages: "Pakiety własne pacjenta",
    doctor_own_packages: "Pakiety własne lekarza",
    cart_pay_for_doctor_referral: "Koszyk opłać zlecenie od lekarza",
    invoice_data: "Dane do faktury",
    collection_points_filters: "Filtry dla Punktów Pobrań",
  },

  collection_points: {
    filters: {
      is_covid_private: "Przystosowany do COVID19",
      is_children: "Przyjazny dzieciom",
      is_40_plus: "Profilaktyka 40+",
      is_ginecology: "Ginekologiczny",
      is_sport: "Sport",
      is_swab: "Pobór wymazów",
      is_parking: "Przy laboratorium",
      open_sunday: "Otwarty w niedzielę",
      open_saturday: "Otwarty w sobotę",
    },
    additional_info: "Dodatkowe informacje",
    additional_open: "Dodatkowe godziny otwarcia",
    additional_close: "Punkt NIECZYNNY",
  },

  doctor_call: {
    header_visit: "Wizyta: {date}",
    show_patient_card: "Zobacz kartę pacjenta",
    issue_referral_for_testing: "Wystaw skierowanie na badania",
    approve_visit_card: "Zatwierdź kartę wizyty",
    interview: "Wywiad",
    test_results: "Wyniki badań",
    order_no: "ZAMÓWIENIE NR: {number}",
    diagnosis: "Rozpoznanie",
    recommendations: "Zalecenia",
    invite_patient: "Zaproś pacjenta do e-Wizyty",
    invite_patient_text:
      "Wyślij mu link w wiadomości e-mail, sms lub innym kanałem",
    join_to_meeting: "Dołącz do spotkania",
    waiting: "Oczekiwanie na dane do połączenia",
    video_placeholder: "Oczekiwanie na pacjenta",
    visit_will_begin: "Wizyta rozpocznie się za:",
    connect: "Połącz",

    navigation: {
      video: "Wideo",
      interview: "Wywaid",
      results: "Wyniki badań",
      research: "Rozpoznanie",
      recommendations: "Zalecenia",
      calendar: "Kalendarz",
    },

    chat: {
      messages: "Wiadomości",
      doctor: "Lekarz",
      patient: "Pacjent",
      response: "Odpowiedz",
    },

    phone_status: {
      started: "Wykonanie połączenia",
      busy: "Zajęty",
      failed: "Niepowodzenie",
      ringing: "Dzwonie",
      timeout: "Brak odpowiedzi",
      answered: "Połączenie odebrane",
      unanswered: "Połączenie nie odebrane",
      completed: "Połączenie zakończone",
      rejected: "Połączenie odrzucone",
    },

    saved: {
      card: "Karta spotkania zapisana.",
      diagnosis: "Diagnoza zapisana.",
      interview: "Wywiad zapisany.",
      recommendations: "Zapisano zalecenia.",
    },

    not_saved: {
      interview: "Wywiad nie został zapisany.",
      recommendations: "Zalecenia nie zostały zapisane.",
    },
  },

  editor: {
    placeholder: "Dodaj opis...",
  },

  header: {
    doctor: {
      dashboard: "Panel główny",
      calendar: "Kalendarz",
      referral: "Wystaw skierowanie",
      history: "Historia zleconych badań",
      patients: "Pacjenci",
      visits: "Wizyty",
      stats: "Statystyki",
    },
    clinic: {
      dashboard: "Panel główny",
      schedule: "Grafik",
      calendar: "Kalendarz",
      patients: "Pacjenci",
      visits: "Wizyty",
      stats: "Statystyki",
    },
  },

  week_days: {
    monday: "Poniedziałek",
    tuesday: "Wtorek",
    wednesday: "Środa",
    thursday: "Czwartek",
    friday: "Piątek",
    saturday: "Sobota",
    sunday: "Niedziela",
  },

  time: {
    mins0: "Bez przerwy",
    mins2: "2 minuty",
    mins5: "5 minut",
    mins10: "10 minut",
    mins15: "15 minut",
    mins30: "30 minut",
    mins45: "45 minut",
    hour: "1 godzina",
  },
  statistics: {
    title: "Statystyki",
  },
  visits: {
    title: "Wizyty",
    statuses: {
      waiting_for_results: "Oczekuje na wyniki",
      canceled_by_doctor: "Anulowana przez lekarza",
      to_be_scheduled: "Do zaplanowania",
      no_show: "Brak dołączenia",
      rescheduled: "Przełożona",
      scheduled: "Zaplanowana",
      completed: "Zakończona",
      ongoing: "W trakcie",
      waiting_for_payment: "Oczekuje na płatność",
    },
  },
  confirm_modal: {
    cancel_button: "Anuluj",
    confirm_button: "Zapisz",
  },
  update_services_modal: {
    title: "Dodaj usługę",
    form: {
      cancel_btn_text: "Anuluj",
      save_btn_text: "Zapisz zmiany",
      inputs: {
        service: "Usługa",
        time_period: "Długość trwania",
        price: "Cena",
        currency: "PLN",
      },
    },
  },
  profile_img_cropper_modal: {
    title: "Edytuj zdjęcie",
    form: {
      delete_btn: "Usuń zdjęcie",
      upload_photo_btn: "Wgraj inne zdjęcie",
      save_btn: "Zapisz",
      cancel_btn: "Anuluj",
      inputs: {
        service: "Usługa",
        time_period: "Długość trwania",
        price: "Cena",
        currency: "PLN",
      },
    },
  },
  choose_current_user_role_modal: {
    title: "Zmień rolę",
    form: {
      delete_btn: "Usuń zdjęcie",
      upload_photo_btn: "Wgraj inne zdjęcie",
      save_btn: "Zapisz",
      cancel_btn: "Anuluj",
      inputs: {
        service: "Usługa",
        time_period: "Długość trwania",
        price: "Cena",
        currency: "PLN",
      },
    },
  },
  user_roles: {
    admin: "Administrator",
    patient: "Pacjent",
    doctor: "Lekarz",
    clinic_owner: "Właściciel kliniki",
    clinic_worker: "Pracownik kliniki",
    clinic_it_specialist: "Informatyk",
  },
  employees: {
    list: {
      title: "Pracownicy",
      search_patient: "Szukaj pracownika",
      action_buttons: {
        add_employee: "Dodaj pracownika",
      },
      columns: {
        status: "Status",
        full_name: "Imię i Nazwisko",
        medic_licence: "Nr licencji medycznej",
        email: "E-mail",
        phoneNumber: "Telefon",
        role: "Rola",
        filled_profile: "Wypełniony profil",
      },
      empty_list: "Lista pracowników jest pusta.",
      employee_status: {
        active: "Aktywny",
        inactive: "Nieaktywny",
        blocked: "Zablokowany",
      },
      employee_role: {
        doctor: "Lekarz",
        clinic_owner: "Właściciel kliniki",
        clinic_worker: "Pracownik kliniki",
        clinic_it_specialist: "Informatyk",
      },
    },
  },
  tests_to_describe: {
    tests_to_describe: "Testy do opisania",
    orders_can_be_taken_by_others:
      "Wszystkie skierowania wystawione dla pacjentów pojawią się tutaj i będą gotowe do opisania, gdy tylko wyniki zostaną wprowadzone do systemu.",
    status: "Status",
    id_order: "Numer skierowania",
    date: "Data",
    age_gender: "Wiek/Płeć",
    due_time: "Pozostały czas",
    test_review_needed: "Testy do weryfikacji",
    salary: "Wynagrodzenie",
    listing_of_tests: "Lista testów",
    leave_test_to_descrive_confirm_info:
      "Czy na pewno chcesz wyjść bez zapisywania zmian?",
    see_patient_survey: "Zobacz ankietę pacjenta",
    basic_information: "Podstawowe informacje",
    gender: "Płeć",
    weight: "Waga",
    height: "Wzrost",
    age: "Wiek",
    issue_referral_checkup: "Wystaw skierowanie",
    description_of_test_results: "Opis wyników testu",
    show_ai_text: "Pokaż tekst AI",
    close_ai_text: "Schowaj tekst AI",
    previous_patient: "Poprzedni pacjent",
    next_patient: "Następny pacjent",
    your_welcome_message: "Wiadomość powitalna",
    your_summary: "Podsumowanie",
    new_type_of_message: "Dodaj nową wiadomość",
    summarize_for_patient_communication:
      "Podsumuj na potrzeby komunikacji z pacjentem",
    generate_health_risk_assessment: "Generowanie oceny ryzyka dla zdrowia",
    create_follow_up_plan: "Utwórz plan działań następczych",
    prescribe_lifestyle_modifications: "Zalecenie modyfikacji stylu życia",
    hints: {
      profile:
        "Zapewnia zwięzły przegląd stanu zdrowia pacjenta na podstawie jego odpowiedzi na kwestionariusz zdrowotny. Obejmuje kluczowe osobiste wskaźniki zdrowotne, historię medyczną oraz wszelkie odnotowane objawy lub obawy.",
      results:
        "Interpretuje i wyjaśnia wyniki badań laboratoryjnych w łatwym do zrozumienia formacie. Podkreśla istotne wyniki, odnotowuje wszelkie nieprawidłowości i oferuje ogólne zrozumienie tego, co te wyniki mogą sugerować na temat zdrowia pacjenta.",
      health_risk_assessment:
        "Ocenia ryzyko wystąpienia różnych schorzeń u pacjenta na podstawie jego historii medycznej, czynników związanych ze stylem życia i wyników badań laboratoryjnych. Identyfikuje potencjalne zagrożenia dla zdrowia i zapewnia wgląd w profilaktyczne środki zdrowotne.",
      follow_up_plan:
        "Określa zalecane kolejne kroki w opiece nad pacjentem, w tym planowanie przyszłych wizyt, dodatkowych badań lub skierowań do specjalistów. Dostosowane do aktualnego stanu zdrowia pacjenta i ostatnich ustaleń medycznych.",
      lifestyle_modifications:
        "Sugeruje zmiany w diecie, ćwiczeniach i innych czynnikach stylu życia w celu poprawy ogólnego stanu zdrowia pacjenta. Te spersonalizowane zalecenia są oparte na informacjach medycznych i stylu życia pacjenta.",
      summarize_for_patient_communication:
        "Przekłada wyniki i zalecenia medyczne na przyjazne dla pacjenta podsumowanie. Ten łatwy do zrozumienia przegląd pomaga pacjentom zrozumieć ich stan zdrowia i działania, które powinni podjąć w przyszłości.",
    },
  },

  quiz: {
    sex: {
      female: "Kobieta",
      male: "Mężczyzna",
    },
  },

  doctor_dashboard: {
    no_tests_1: "Nie masz jeszcze żadnego testu do opisania.",
    no_tests_2:
      "Wystaw skierowanie, a wyniki testów pojawią się tutaj dla opisu",
  },

  range_level: {
    low: "Niski",
    high: "Wysoki",
    normal: "Normalny",
  },

  video: {
    waiting_room: "Poczekalnia",
    loading: {
      title: "Oczekiwanie na połączenie",
    },
    microphone: "Mikrofon",
    speaker: "Głośnik",
    camera: "Kamera",
    join_to_meeting: "Dołącz",
    no_device: "Brak",
  },
};
